<template>
    <div aria-atomic="true" aria-live="polite" class="container">
        <div aria-label="Os Online" ref="banner" role="banner">
            <app-banner/>
        </div>

        <div class="content-card-index-container justify-content-center row">
            <content-card
                    class="col-sm content-card-student-student"
                    media="misc/btn-icon-thumbs-up.png"
                    title="Meld klar"
                    type="student"
                    v-on:onClick="onSelectStudent"
            />

            <content-card
                    class="col-sm content-card-student-single-player"
                    media="misc/btn-icon-check"
                    title="Prøv selv"
                    type="student"
                    v-on:onClick="onSelectSinglePlayer"
            />

            <content-card
                    class="col-sm content-card-student-youth-advice"
                    media="misc/btn-icon-bubbles"
                    title="Unge rådgivning"
                    type="student"
                    v-on:onClick="onSelectYouthAdvice"
            ><img :src="redcrossLogoUrl"/></content-card>
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/app-button'
    import AppBanner from '@/components/app-banner'
    import {getSinglePlayerUrl, getStudentUrl} from '@/utils/UrlUtil'
    import {MediaUtil} from "@/utils/MediaUtil";
    import ContentCard from '@/components/content-card'

    export default {
        components: {
            AppButton,
            AppBanner,
            ContentCard
        },
        data() {
            return {
                redcrossLogoUrl: MediaUtil.getMediaUrl('misc/redcross-logo.png')
            }
        },
        computed: {
            breadcrumbTo() {
                return getStudentUrl('connect');
            }
        },
        methods: {
            onSelectStudent() {
                this.$router.push(getStudentUrl('connect'));
            },
            onSelectSinglePlayer() {
                this.$router.push(getSinglePlayerUrl('connect'));
            },
            onSelectYouthAdvice() {
                window.href = 'https://www.rodekors.dk/';
            },
        }
    }
</script>

<style lang="less" scoped>
    .splash-image {
        background: url("~@img/backgrounds/splash.png") no-repeat center center;

        position: absolute;
        top: 40%;
        left: 50%;

        width: 313px;
        height: 173px;

        transform: translate(-50%, -50%);
    }

    .start-button {
        position: absolute;
        top: 80%;
        left: 50%;

        transform: translate(-50%, -50%);
    }

    .content-card {
        &.content-card-student {
            color: white;
            font-weight: bold;
            font-size: 30pt;
            text-transform: uppercase;
            font-family: "Titillium Web", sans-serif;
        }

        &.content-card-student-student {
            background: #0e9512;
        }

        &.content-card-student-single-player {
            background: #e24265;
        }

        &.content-card-student-youth-advice {
            background: #2d233e;

            img {
                position: absolute;
                top: 10px;
                right: 10px;
            }
        }
    }
</style>